import { Topic } from 'widgets/myPortfolioCapsules/topics/Topic';
import { TopicType } from 'widgets/myPortfolioCapsules/topics/TopicType';
import React from 'react';
import { costTopic } from 'widgets/myPortfolioCapsules/topics/costs/costTopic';

export const adjustedCostTopic: Topic = {
    ...costTopic({
        costField: 'exCost',
        valueField: 'exCostWeightedByTradedValue',
        absValueField: 'exCostAbsWeightedByTradedValue',
    }),
    type: TopicType.AdjustedCost,
    description: 'Adjusted Cost',
    help: (
        <div>
            A market adjusted or index adjusted performance measure is intended
            to account for price movement in the stock due to the market,
            sector, or industry movement. This is computed using the
            stock&apos;s sensitivity to the underlying index and the actual
            movement of that index as a proxy for the natural price appreciation
            of the stock (e.g., how the stock price would have changed if the
            order was not released to the market). This topic ranks symbols by
            their value-weighted Estimated Cost in basis points as calculated by
            either Instinet&apos;s proprietary Market Impact Model or the METRIC
            model. You can sort by ascending or descending and configure the
            number of symbols you would like to display. You can configure the
            model to be used in settings.
        </div>
    ),
    deriveShouldExcludeZeros: () => true,
};
